/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-09-11 14:38:01
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'


/**
 * @description: 获取文件流
 * @param {
* }
* @return {*}
*/
export const downloadAttachFile = (data) => {
   return axios.request({
       url: `${API_MAIN}/downloadAttachFile`,
       method: 'get',
       params:data,
       responseType:"arraybuffer"
   })
}

/**
 * @description: 获取门户轮播图文件流
 * @param {
* }
* @return {*}
*/
export const getFileContentCache = (data) => {
    return axios.request({
      url: `${API_MAIN}/getFileContentCache`,
      method: 'get',
      params: data,
      responseType: "arraybuffer"
    });
  };

/**
 * @description: 获取文件流
 * @param {
* }
* @return {*}
*/
export const getFileById = (data) => {
   return axios.request({
       url: `${API_MAIN}/getFileById`,
       method: 'get',
       params:data,
       responseType:"arraybuffer"
   })
}
/**
 * @description: 获取门户教师培训url
 * @param {
* }
* @return {*}
*/
export const getGwUrlJspx = (data) => {
    return axios.request({
        url: `${API_MAIN}/getGwUrlJspx`,
        method: 'get',
        params:data
    })
}
/**
 * @description: 获取书香燕京url
 * @param {
* }
* @return {*}
*/
export const getGwUrlSxyj = (data) => {
    return axios.request({
        url: `${API_MAIN}/getGwUrlSxyj`,
        method: 'get',
        params:data
    })
}

/**
 * @description: 获取办学条件业务系统入口url
 * @param {
* }
* @return {*}
*/
export const gwUrlbxtj = (data) => {
    return axios.request({
        url: `${API_MAIN}/gwUrlbxtj`,
        method: 'get',
        params:data
    })
}





// WEBPACK FOOTER //
// ./src/api/common.js